import URLSearchParams from "@ungap/url-search-params";

/**
 * Обработка параметров в URL
 *
 * @param {Location} location Объект window.location
 */
export default function URLParams(location) {
  this.location = location;
  this.URLSearchParams = new URLSearchParams(location.search);
}

/**
 * Получить значение параметра из URL
 *
 * @param {string} name Название параметра
 * @returns {string|null}
 */
URLParams.prototype.get = function URLParamsGet(name) {
  return this.URLSearchParams.get(name);
}

/**
 * Получить текстовое представление ссылки
 *
 * @returns {string}
 */
URLParams.prototype.getHref = function URLParamsGetHref() {
  var url = this.location.origin + this.location.pathname;
  return url + '?' + this.URLSearchParams.toString();
}

/**
 * Проверка наличия парамертра в URL
 *
 * @param {string} name
 * @returns {boolean}
 */
URLParams.prototype.has = function URLParamsHas(name) {
  return this.URLSearchParams.has(name);
}

/**
 * Установить значение параметра в URL
 *
 * @param {any} name Название параметра
 */
URLParams.prototype.set = function URLParamsSet(name, value) {
  this.URLSearchParams.set(name, value)
}
